export const CHARMAP = [
  [8251, "Reference Mark"],
  [9734, "White Star"],
  [9733, "Black Star"],
  [9675, "White Circle"],
  [9679, "Black Circle"],
  [9678, "Bullseye"],
  [9671, "White Diamond"],
  [9670, "Black Diamond"],
  [9633, "White Square"],
  [9632, "Black Square"],
  [9651, "White Up-Pointing Triangle"],
  [9650, "Black Up-Pointing Triangle"],
  [9661, "White Down-Pointing Triangle"],
  [9660, "Black Down-Pointing Triangle"],
  [8594, "Rightwards Arrow"],
  [8592, "Leftwards Arrow"],
  [8593, "Upwards Arrow"],
  [8595, "Downwards Arrow"],
  [8596, "Left Right Arrow"],
  [9665, "White Left-Pointing Triangle"],
  [9664, "Black Left-Pointing Triangle"],
  [9655, "White Right-Pointing Triangle"],
  [9654, "Black Right-Pointing Triangle"],
  [9828, "White Spade Suit"],
  [9824, "Black Spade Suit"],
  [9825, "White Heart Suit"],
  [9829, "Black Heart Suit"],
  [9831, "White Club Suit"],
  [9827, "Black Club Suit"],
  [8857, "Circled Dot Operator"],
  [9672, "White Diamond Containing Black Small Diamond"],
  [9635, "White Square Containing Black Small Square"],
  [9680, "Circle with Left Half Black"],
  [9681, "Circle with Right Half Black"],
  [9618, "Medium Shade"],
  [9636, "Square with Horizontal Fill"],
  [9637, "Square with Vertical Fill"],
  [9640, "Square with Upper Right To Lower Left Fill"],
  [9639, "Square with Upper Left To Lower Right Fill"],
  [9638, "Square with Orthogonal Crosshatch Fill"],
  [9641, "Square with Diagonal Crosshatch Fill"],
  [9832, "Hot Springs"],
  [9742, "Black Telephone"],
  [9756, "White Left Pointing Index"],
  [9758, "White Right Pointing Index"],
  [182, "Pilcrow Sign"],
  [8224, "Dagger"],
  [8225, "Double Dagger"],
  [8597, "Up Down Arrow"],
  [8599, "North East Arrow"],
  [8601, "South West Arrow"],
  [8598, "North West Arrow"],
  [8600, "South East Arrow"],
  [9837, "Music Flat Sign"],
  [9833, "Quarter Note"],
  [9834, "Eighth Note"],
  [9836, "Beamed Sixteenth Notes"],
  [12927, "Korean Standard Symbol"],
  [8470, "Numero Sign"],
  [13255, "Square Co"],
  [8482, "Trade Mark Sign"],
  [174, "Registered Sign"],
  [170, "Feminine Ordinal Indicator"],
  [186, "Masculine Ordinal Indicator"],
  [177, "Plus minus symbol"],
  [215, "Multiplication Sign"],
  [247, "Division Sign"],
  [8800, "Not Equal To"],
  [8804, "Less-Than or Equal To"],
  [8805, "Greater-Than or Equal To"],
  [8734, "Infinity"],
  [8756, "Therefore"],
  [9794, "Male Sign"],
  [9792, "Female Sign"],
  [8736, "Angle"],
  [8869, "Up Tack"],
  [8978, "Arc"],
  [8706, "Partial Differential"],
  [8711, "Nabla"],
  [8801, "Identical To"],
  [8786, "Approximately Equal To or the Image Of"],
  [8810, "Much Less-Than"],
  [8811, "Much Greater-Than"],
  [8730, "Square Root"],
  [8765, "Reversed Tilde"],
  [8733, "Proportional To"],
  [8757, "Because"],
  [8747, "Integral"],
  [8748, "Double Integral"],
  [8712, "Element Of"],
  [8715, "Contains As Member"],
  [8838, "Subset of or Equal To"],
  [8839, "Superset of or Equal To"],
  [8834, "Subset Of"],
  [8835, "Superset Of"],
  [8746, "Union"],
  [8745, "Intersection"],
  [8743, "Logical And"],
  [8744, "Logical Or"],
  [8704, "For All"],
  [8707, "There Exists"],
  [8750, "Contour Integral"],
  [8721, "N-Ary Summation"],
  [8719, "N-Ary Product"],
  [183, "Middle Dot"],
  [711, "Caron"],
  [728, "Breve"],
  [730, "Ring Above"],
  [729, "Dot Above"],
  [161, "Inverted Exclamation Mark"],
  [191, "Inverted Question Mark"],
  [12298, "Left Double Angle Bracket"],
  [12299, "Right Double Angle Bracket"],
  [12300, "Left Corner Bracket"],
  [12301, "Right Corner Bracket"],
  [12910, "Circled Hangul Kiyeok A"],
  [12911, "Circled Hangul Nieun A"],
  [12912, "Circled Hangul Tikeut A"],
  [12913, "Circled Hangul Rieul A"],
  [12914, "Circled Hangul Mieum A"],
  [12915, "Circled Hangul Pieup A"],
  [12916, "Circled Hangul Sios A"],
  [12917, "Circled Hangul Ieung A"],
  [12918, "Circled Hangul Cieuc A"],
  [12919, "Circled Hangul Chieuch A"],
  [12920, "Circled Hangul Khieukh A"],
  [12921, "Circled Hangul Thieuth A"],
  [12922, "Circled Hangul Phieuph A"],
  [12923, "Circled Hangul Hieuh A"],
  [9424, "Circled Latin Small Letter A"],
  [9425, "Circled Latin Small Letter B"],
  [9426, "Circled Latin Small Letter C"],
  [9427, "Circled Latin Small Letter D"],
  [9428, "Circled Latin Small Letter E"],
  [9429, "Circled Latin Small Letter F"],
  [9430, "Circled Latin Small Letter G"],
  [9431, "Circled Latin Small Letter H"],
  [9432, "Circled Latin Small Letter I"],
  [9433, "Circled Latin Small Letter J"],
  [9434, "Circled Latin Small Letter K"],
  [9435, "Circled Latin Small Letter L"],
  [9436, "Circled Latin Small Letter M"],
  [9437, "Circled Latin Small Letter N"],
  [9438, "Circled Latin Small Letter O"],
  [9439, "Circled Latin Small Letter P"],
  [9440, "Circled Latin Small Letter Q"],
  [9441, "Circled Latin Small Letter R"],
  [9442, "Circled Latin Small Letter S"],
  [9443, "Circled Latin Small Letter T"],
  [9444, "Circled Latin Small Letter U"],
  [9445, "Circled Latin Small Letter V"],
  [9446, "Circled Latin Small Letter W"],
  [9447, "Circled Latin Small Letter X"],
  [9448, "Circled Latin Small Letter Y"],
  [9449, "Circled Latin Small Letter Z"],
  [9312, "Circled Digit One"],
  [9313, "Circled Digit Two"],
  [9314, "Circled Digit Three"],
  [9315, "Circled Digit Four"],
  [9316, "Circled Digit Five"],
  [9317, "Circled Digit Six"],
  [9318, "Circled Digit Seven"],
  [9319, "Circled Digit Eight"],
  [9320, "Circled Digit Nine"],
  [9321, "Circled Number Ten"],
  [65284, "Fullwidth Dollar Sign"],
  [65510, "Fullwidth Won Sign"],
  [8451, "Degree Celsius"],
  [8491, "Angstrom Sign"],
  [65504, "Fullwidth Cent Sign"],
  [65505, "Fullwidth Pound Sign"],
  [65509, "Fullwidth Yen Sign"],
  [164, "Currency Sign"],
  [8457, "Degree Fahrenheit"],
  [8240, "Per Mille Sign"],
  [8364, "Euro Sign"],
  [13205, "Square Mu L"],
  [13206, "Square Ml"],
  [13207, "Square Dl"],
  [8467, "Script Small L"],
  [13208, "Square Kl"],
  [13252, "Square Cc"],
  [13219, "Square Mm Cubed"],
  [13220, "Square Cm Cubed"],
  [13221, "Square M Cubed"],
  [13222, "Square Km Cubed"],
  [13209, "Square Fm"],
  [13210, "Square Nm"],
  [13211, "Square Mu M"],
  [13212, "Square Mm"],
  [13213, "Square Cm"],
  [13214, "Square Km"],
  [13215, "Square Mm Squared"],
  [13216, "Square Cm Squared"],
  [13217, "Square M Squared"],
  [13218, "Square Km Squared"],
  [13258, "Square Ha"],
  [13197, "Square Mu G"],
  [13198, "Square Mg"],
  [13199, "Square Kg"],
  [13263, "33CF"],
  [13192, "Square Cal"],
  [13193, "Square Kcal"],
  [13256, "Square Db"],
  [13223, "Square M Over S"],
  [13224, "Square M Over S Squared"],
  [13232, "Square Ps"],
  [13233, "Square Ns"],
  [13234, "Square Mu S"],
  [13235, "33B3"],
  [13200, "Square Hz"],
  [13201, "Square Khz"],
  [13202, "Square Mhz"],
  [13203, "Square Ghz"],
  [8486, "Ohm Sign"]
];
